
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5 6a13.41 13.41 0 019.546 3.954A13.412 13.412 0 0133 19.5c0 3.606-1.404 6.996-3.954 9.546A13.41 13.41 0 0119.5 33a13.41 13.41 0 01-9.545-3.954A13.412 13.412 0 016 19.5c0-3.606 1.404-6.996 3.954-9.546A13.41 13.41 0 0119.5 6zm0-2C10.94 4 4 10.94 4 19.5 4 28.06 10.94 35 19.5 35 28.06 35 35 28.06 35 19.5 35 10.94 28.06 4 19.5 4z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.824 19.105l5.831-5.832-1.414-1.414-7.245 7.246 7.245 7.246 1.414-1.414-5.831-5.832z"}})])
          )
        }
      }
    